import React from 'react';
import SimpleFileUpload from '../components/SimpleFileUpload';

const TestUpload = () => {
  const handleFileSelect = (file) => {
    console.log('File selected:', file);
  };

  const handleFileRemove = () => {
    console.log('File removed');
  };

  return (
    <div className="min-h-screen bg-gray-100 p-8">
      <div className="max-w-2xl mx-auto">
        <h1 className="text-3xl font-bold mb-8">File Upload Test</h1>
        
        <div className="bg-white p-6 rounded-lg shadow">
          <h2 className="text-xl font-semibold mb-4">Simple File Upload Test</h2>
          <SimpleFileUpload
            onFileSelect={handleFileSelect}
            onFileRemove={handleFileRemove}
            maxSize={10}
          />
        </div>
      </div>
    </div>
  );
};

export default TestUpload;
